'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Pill_web = require('../../atoms/Pill/Pill.web.cjs');
var FullscriptLogo = require('../icons/FullscriptLogo.cjs');

/**
 * Pill to indicate content is featured by Fullscript
 *
 * {@link https://aviary.fullscript.io/latest/components/preferred-pill/web-gh33oXc1 | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/platform/PreferredPill/PreferredPill.web.tsx | View in GitLab}
 *
 * @scope Platform
 */ const PreferredPill = ({ ...rest })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(Pill_web.Pill, {
        customSvg: /*#__PURE__*/ jsxRuntime.jsx(FullscriptLogo.FullscriptLogo, {}),
        intention: "success",
        tooltipContent: "Meets select criteria for quality, clinical utility, and evidence",
        size: "small",
        ...rest,
        children: "Top pick"
    });
};

exports.PreferredPill = PreferredPill;
//# sourceMappingURL=PreferredPill.web.cjs.map
